
import { IconNames } from "@blueprintjs/icons";
import * as React from "react";

import { ID } from "common/entities/IEntity";
import Loading from "common/fragments/Loading";
import NonIdealState from "common/fragments/NonIdealState";
import { BlockVariant, BlockView } from 'common/views/block/BlockView.view';
import { ButtonVariant, ButtonView } from 'common/views/button/Button.view';
import { CardView } from 'common/views/card/Card.view';
import HeadingView, { HeadingVariant } from 'common/views/heading/Heading.view';
import { ImageVariant, ImageView } from 'common/views/image/Image.view';
import { isEmpty } from "core/util/ArrayUtils";
import { CourseWrapper } from "../../common/entities/courseWrapper/CourseWrapper";
import { Query } from "../../core/api/typedQuery";
import { IPanelProps, Panel } from "../../core/decorators/Panel";
import {  nDef } from "../../core/util/TypeUtils";
import Featured from "./entities/Featured";
import { FeaturedItemsPanelConfig, ListTypeOptions } from "./FeaturedItemsPanelConfig";
import labelProvider from './FeaturedItems.labels';
import { CarouselView } from "common/views/carousel/Carousel.view";
import { RowsView } from "common/views/rows/Rows.view";
import { FragmentLayout } from "../../core/components/FragmentLayout";
import * as featuredFragments from "./displayFragments";
import { desaturate } from "polished";
import * as displayFragments from "../catalog/fragments/course/displayFragments"
import Course from "../catalog/entities/Course";
import QueryRoot from "core/api/QueryComponent";
import { Spinner } from "@blueprintjs/core";
import { Field } from "typegraph";
import ICourseFragmentProps from "../catalog/fragments/course/ICourseFragmentProps";
import * as catalogActions from "../catalog/catalogActions";
import * as actionFragments from "../catalog/fragments/course/actionFragments";


function mapParams(data) {
	const params = {...data}; //clone

	//remove fields which are not using in query
	delete params['loadPrograms'];

	return {params: params};
}
class CourseQuery {
	@Field({
		entity: Course,
		params: mapParams,
		aliasFor: "course_one"
	})
	public course: Course;
}
const { Labels } = labelProvider;
interface IFeaturedParam {
		pageSize?: number;
		ids?: ID[];
}

const FeaturedQuery = Query.queryMany<Featured, IFeaturedParam>(Featured);

@Panel({id: "featuredItems", configClass: FeaturedItemsPanelConfig,labelProvider})
class FeaturedItemsPanel extends React.Component<IPanelProps<FeaturedItemsPanelConfig>> {

	public render() {
		const { config } = this.props;
		let params;
		if(config.featuredIds === undefined || nDef(config.featuredIds) || config.featuredIds.length < 1 || !config.showCustFI) {
			params = {pageSize: config.pageSize };
		} else {
			params = {pageSize: config.pageSize, ids : config.featuredIds};
		}

		return (
			<FeaturedQuery params={params}>
				{
					({data, loading}) => {

						if(loading) {
							return <Loading />;
						}

						if (isEmpty(data)) {
							return (
								<NonIdealState
									title={<Labels.FeaturedCoursesEmpty/>}
									description={<Labels.DescriptionEmpty />}
								/>
							);
						}

						const items = data.map((featured) => this.renderFeatured(featured, config));
						if (items && items.length < 4 && (config.view === ListTypeOptions.CAROUSEL || config.view === ListTypeOptions.ROWS)) {
							return (
								<RowsView key="rows" viewKey="rows">
									{items}
								</RowsView>
							)
						}

						if (config.view === ListTypeOptions.CAROUSEL) {

							return (
								<CarouselView
									items={items}
									key="carousel"
									viewKey="carousel"
								/>
							);
						}

						if (config.view === ListTypeOptions.ROWS) {

							return (
								<RowsView key="rows" viewKey="rows">
									{items}
								</RowsView>
							);
						}

						return items;
					}
				}
			</FeaturedQuery>
		);
	}

	private renderFeatured = (featured: Featured, config: FeaturedItemsPanelConfig) => {
		if(featured.entry) {
		const w = CourseWrapper.forEntry(featured.entry);

			// const content = [
			// 	<FragmentLayout
			// 		layout={this.props.config.courseFragmentsLayout}
			// 		fragments={{ ...displayFragments }}
			// 		props={{
			// 			item: {
			// 				title: w.getTitle(),
			// 				description: w.getDescription() && w.getDescription().length > 200 ? w.getDescription().substr(0, 200) + "..." : w.getDescription(),
			// 				status: w.getCompletion() == null ? "Not Started" : w.getCompletion(),
			// 				iconUrl: w.getIconUrl(),
			// 				lunchFunction : () => w.launchCourse()
			// 		} }}
			// 		/>

			// // 			<ImageView key="icon" style={{width: "100%", height: "150px"}} variant={ImageVariant.THUMBNAIL}
			// // 				src={w.getIconUrl()} viewKey="icon" />,

			// // 			<BlockView variant={BlockVariant.CARD_CONTENT} viewKey="card-primary" key="card-primary">
			// // 				<HeadingView children={w.getTitle()} variant={HeadingVariant.H3} viewKey="course-title" />
			// // 			</BlockView>,

			// // 			<BlockView variant={BlockVariant.CARD_CONTENT} viewKey="course-subtitle" key="card-subtitle">
			// // 				<HeadingView viewKey="course-subtitle" >
			// //                         <div dangerouslySetInnerHTML={{__html: w.getDescription() && w.getDescription().length > 200 ? w.getDescription().substr(0, 200) + "..." : w.getDescription() }} />
			// // 				</HeadingView>
			// // 			</BlockView>,

			// // 			<BlockView variant={BlockVariant.CARD_CONTENT} viewKey="course-status" key="course-status">
			// // 			<HeadingView viewKey="course-status-label">
			// // 				<Labels.CourseStatus />
			// // 			</HeadingView>
			// // 			<HeadingView  viewKey="course-status" children={w.getCompletion() == null ? "Not Started" : w.getCompletion()} />
			// // 			</BlockView>,

			// // 			<ButtonView key="launchLink" variant={ButtonVariant.PRIMARY} viewKey="launch.link" onClick={() => w.launchCourse()}>
			// // 				<Labels.Launch />
			// // 			</ButtonView>


			// ];

			const params = {id:featured.entry.id}

			return (
				<QueryRoot.Root entity={CourseQuery} args={params}>
									{
					({data, loading}) => {

						if(loading) {
							return (
								<Spinner size={Spinner.SIZE_STANDARD} />
							);
						}
						const course = data && data.course;

						if (!course) {
							return <React.Fragment></React.Fragment>;
						}
						const courseProps = {
							course: course,
							actions: catalogActions,
							item: {
								status: w.getCompletion() == null ? "Not Started" : w.getCompletion(),
								lunchFunction : () => w.launchCourse()
			 				},
							imageURL : featured.imageURL,
							showCustomFields: config.showCustomFields,
							disableDirectBuy: config.disableDirectBuy
						};
						return (
							<CardView key={w.getItemId()} viewKey="card">
								<FragmentLayout
									layout={this.props.config.courseFragmentsLayout}
									fragments={{...actionFragments, ...displayFragments,...featuredFragments }}
									props={courseProps}
								/>
						   </CardView>
						);
					}
				}

			</QueryRoot.Root>
		);
		}
	}
}




// WEBPACK FOOTER //
// ./src/panels/featuredItems/FeaturedItems.panel.tsx